const FillableList = () => import("./FillableList.vue");

export default {
  install(Vue) {
    Vue.component("fp-form-fillable-list", FillableList);
  },
};
